import React from "react";

export default function Base({}) {
	return <>
		<rect width="100" height="100" rx="15" />
	</>
}